import { CircularProgress, List, ListItem, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SelectField from "../../../Components/SelectField";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: "520px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateLegalEntityDialog = ({
  LegalhandleClose,
  Legalopen,
  LegalEntity,
  setLegalEntity,
  errors,
  createLegalEntity,
  isLoading,
  AllEmployee,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={LegalhandleClose}
      aria-labelledby="customized-dialog-title"
      open={Legalopen}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={LegalhandleClose}
      >
        <div className="foundation_header">
          Create Legal Entity Country Specific
        </div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={LegalEntity?.name}
              onChange={(e) =>
                setLegalEntity({ ...LegalEntity, name: e.target.value })
              }
            />
          </div>

          {/* <div className="Box">
            <label>Head of Legal Entity</label>
            <SelectField
              name="head_of_unit"
              onChange={(e) =>
                setLegalEntity({
                  ...LegalEntity,
                  hod: e.value,
                })
              }
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === LegalEntity?.hod
              )}
            />
          </div> */}

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={LegalEntity?.description}
              onChange={(e) => setLegalEntity({...LegalEntity, description: e.target.value})}
            />
            {errors.description && <p>Description is required.</p>}
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={LegalhandleClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={createLegalEntity}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditLegalDialog = ({
  handleEditLegalClose,
  editLegal,
  LegalEntity,
  setLegalEntity,
  updateLegalEntity,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleEditLegalClose}
      aria-labelledby="customized-dialog-title"
      open={editLegal !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleEditLegalClose}
      >
        <div className="foundation_header">Edit Legal Entity</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={LegalEntity.name}
              onChange={(e) => setLegalEntity({ ...LegalEntity, name: e.target.value })}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={LegalEntity.description}
              onChange={(e) =>
                setLegalEntity({ ...LegalEntity, description: e.target.value })
              }
            />
          </div>

          {/* <div className="Box">
            <label>Effective Status</label>
            <select
              name="effectiveStatus"
              value={Grade.grade_status}
              onChange={(e) => setGrade({ ...Grade, status: e.target.value })}
              id=""
            >
              <option value="">Choose status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleEditLegalClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={updateLegalEntity}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteLegalDialog = ({
  handleDeleteLegalClose,
  deleteLegal,
  deleteLegalEntity,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleDeleteLegalClose}
      aria-labelledby="customized-dialog-title"
      open={deleteLegal !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleDeleteLegalClose}
      >
        <div className="foundation_header">Delete Legal Entity</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Confirmation">Are you sure?</div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleDeleteLegalClose} className="Btn">
            Cancel
          </button>
          <button
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
            className="Delete_Btn"
            onClick={deleteLegalEntity}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const ViewLegalDialog = ({ handleViewLegalClose, LegalViewopen }) => {
  return (
    <BootstrapDialog
      onClose={handleViewLegalClose}
      aria-labelledby="customized-dialog-title"
      open={LegalViewopen !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleViewLegalClose}
      >
        <div className="foundation_header">View Legal Entity</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <List>
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Name</label>
            <p>{LegalViewopen?.name}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
\          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Description</label>
            <p>{LegalViewopen?.description}</p>
          </ListItem>
        </List>
      </DialogContent>
    </BootstrapDialog>
  );
};
